import React, { useState, forwardRef, useImperativeHandle } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//const { useTranslation } = Hooks;
//import store from "store";
import styles from "./index.module.scss";
export interface PaginationRefProps {
  enablePre: () => void;
  enableNext: (flag?: boolean) => void;
}
export interface PaginationProps {
  ref?: CompRef<PaginationRefProps>;
  className?: string;
  pageIndex?: number;
  prepage?(callback?: () => any): void;
  nextpage?(callback?: (flag?: boolean) => any): void;
}
const Pagination = ({ className = "", pageIndex = 1, prepage, nextpage }: PaginationProps, ref: PaginationProps["ref"]) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  // useState
  const [preDisable, setPreDisable] = useState(false);
  const [nextDisable, setNextDisable] = useState(false);

  // method
  const handlePreBtn = () => {
    if (preDisable || pageIndex <= 1) return;
    setPreDisable(true);
    prepage && prepage(enablePre);
  };

  const handleNextBtn = () => {
    if (nextDisable) return;
    setNextDisable(true);
    nextpage && nextpage(enableNext);
  };

  const enablePre = () => {
    setPreDisable(false);
    setNextDisable(false);
  };
  const enableNext = (flag = false) => {
    setNextDisable(flag);
  };

  useImperativeHandle(ref, () => ({
    enablePre,
    enableNext,
  }));

  return (
    <div className={cx(styles["pagination-main"], "xt-pagination", className)}>
      <div className="xt-page">
        <div className={cx("page-pre", (preDisable || pageIndex <= 1) && "disable")} onClick={handlePreBtn}>
          <i></i>
        </div>
        <div className="page-text"> {pageIndex}</div>
        <div className={cx("page-next", nextDisable && "disable")} onClick={handleNextBtn}>
          <i></i>
        </div>
      </div>
    </div>
  );
};
export default observer(forwardRef(Pagination), { forwardRef: true }) as React.FC<PaginationProps>;
